<div class="container" id="rewards">
  <div class="row">
    <div class="col-xs-12 contentContainer paddingBottom-0">
      <div class="learnContainer">
        <div class="container">
          <p>{{contentLearnMore?.text}} <a href={{contentLearnMore?.linkURL}} tabindex="0" [title]="contentLearnMore?.linkLable"
              target="_blank" rel="noopener"><strong>{{contentLearnMore?.linkLable}}
                &gt;</strong></a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
